import { CircleAlert, AlertTriangle, Info } from 'lucide-react'

interface TopIssue {
  type: string
  title: string
  severity: string
  count: number
}

interface TopIssuesListProps {
  issues: TopIssue[]
  onClickIssue?: (type: string) => void
}

const SEVERITY_ICON = {
  critical: { Icon: CircleAlert, color: 'text-red-500', bg: 'bg-red-50' },
  warning: { Icon: AlertTriangle, color: 'text-amber-500', bg: 'bg-amber-50' },
  info: { Icon: Info, color: 'text-blue-500', bg: 'bg-blue-50' },
}

export function TopIssuesList({ issues, onClickIssue }: TopIssuesListProps) {
  return (
    <div className="space-y-2">
      {issues.map((issue, i) => {
        const config = SEVERITY_ICON[issue.severity as keyof typeof SEVERITY_ICON] || SEVERITY_ICON.info
        const { Icon, color, bg } = config
        return (
          <button
            key={i}
            onClick={() => onClickIssue?.(issue.type)}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl hover:bg-[#F4F5FA] transition-colors text-left group"
          >
            <div className={`w-7 h-7 rounded-lg ${bg} flex items-center justify-center shrink-0`}>
              <Icon className={`w-3.5 h-3.5 ${color}`} strokeWidth={1.5} />
            </div>
            <span className="text-sm text-[#1B2559] flex-1 truncate group-hover:text-orion-primary transition-colors">
              {issue.title}
            </span>
            <span className="font-mono text-sm font-semibold text-[#1B2559] shrink-0">
              {issue.count}
            </span>
          </button>
        )
      })}
    </div>
  )
}
